module.exports = __webpack_public_path__ + "img/Expenses-for-Public-Relations.9b72368f.png";